import api from '@/api'

const state = {
}

const mutations = {
}

const actions = {
  // 获取数据字典列表
  async getDataDictionaryList ({commit, state}, payload) {
    const {data} = await api.deployApi.getDataDictionaryList(payload)
    return data
  },
  // 新增数据字典
  async addDataDictionary ({commit, state}, payload) {
    const {code, message} = await api.deployApi.addDataDictionary(payload)
    return {code, message}
  },
  // 编辑数据字典
  async editDataDictionary ({commit, state}, payload) {
    const {code, message} = await api.deployApi.editDataDictionary(payload)
    return {code, message}
  },
  // 删除数据字典
  async deleteDataDictionary ({commit, state}, payload) {
    const {data} = await api.deployApi.deleteDataDictionary(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
